import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LanguageModule } from '@language';
import { ShLoadingComponent } from '@stylehaven/components';
import { NavigationLoadingComponent } from './components/navigation-loading/navigation-loading.component';

@NgModule({
    declarations: [NavigationLoadingComponent],
    imports: [CommonModule, LanguageModule, ShLoadingComponent],
    exports: [NavigationLoadingComponent]
})
export class LoadingModule {}

export { NavigationLoadingComponent } from './components/navigation-loading/navigation-loading.component';
